import React, { useState } from "react";
import Header from "../components/Header";
import data from "../data/data.json";
import { useMediaQuery } from "react-responsive";

const Technology = () => {
  const technoData = data.technology;
  const [idChoice, setIdChoice] = useState(0);
  const isDesktop = useMediaQuery({ minWidth: 1064 });

  const handleChoice = (e) => {
    const techno = e.target.id;
    const choice = technoData.find((item) => item.name === techno);
    if (choice) {
      setIdChoice(technoData.indexOf(choice));
    }
  };

  return (
    <div className="techno-container">
      <Header />
      <main className="techno-content">
        <h5 className=" wrapper">
          <span>03</span> Space launch 101
        </h5>
        <div>
          <img
            src={
              isDesktop
                ? technoData[idChoice].images.portrait
                : technoData[idChoice].images.landscape
            }
            alt={technoData[idChoice].name}
          />
          <ul className="radio-container wrapper">
            {technoData.map((techno, index) => {
              return (
                <li key={index}>
                  <input
                    type="radio"
                    name="techno"
                    id={techno.name}
                    onInput={(e) => handleChoice(e)}
                    defaultChecked={index === 0}
                  />
                  <label htmlFor={techno.name}>{index + 1}</label>
                </li>
              );
            })}
          </ul>
          <div className="techno-content-description wrapper">
            <span> The terminology...</span>
            <h3>{technoData[idChoice].name}</h3>
            <p>{technoData[idChoice].description}</p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Technology;
